import { useMemo } from 'react';
import { useLocation } from 'react-use';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useTranslation } from '../../services/translation/hooks/useTranslation';
import { DebugIcon } from '../navbar/components/icons/DebugIcon';
import { NavbarIconButtonWithLabel } from '../navbar/components/NavbarIconButtonWithLabel';
import { DebugInfoDialogCollections } from './collections/DebugInfoDialogCollections';
import { selectDebugOpen, setDebugOpen } from './debugSlice';
import DebugInfoDialogOnboarding from './onboarding/DebugInfoDialogOnboarding';
import DebugInfoDialog from './ranchAndBlock/DebugInfoDialog';

const DebugInfoLauncher = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const open = useAppSelector(selectDebugOpen);

  const handleClick = () => dispatch(setDebugOpen(!open));

  const currDebugDialog = useMemo(() => {
    const path = location.pathname;

    if (path?.includes('onboarding')) {
      return (
        <DebugInfoDialogOnboarding
          open={open}
          onClose={() => dispatch(setDebugOpen(false))}
        />
      );
    } else if (path?.includes('collections') || path?.includes('scans')) {
      return (
        <DebugInfoDialogCollections
          open={open}
          onClose={() => dispatch(setDebugOpen(false))}
        />
      );
    } else {
      return (
        <DebugInfoDialog
          open={open}
          onClose={() => dispatch(setDebugOpen(false))}
        />
      );
    }
  }, [location.pathname, open]);

  return (
    <>
      <NavbarIconButtonWithLabel
        active={open}
        label={t('Debug Info')}
        onClick={handleClick}
      >
        <DebugIcon />
      </NavbarIconButtonWithLabel>
      {currDebugDialog}
    </>
  );
};

export default DebugInfoLauncher;
